import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Ink from 'react-ink';

import ReactModal from 'react-modal';
import * as ModalsActions from '../ModalsActions';
import { setContentBlur } from '../../app/AppActions';
import './Style';

class DraftModalContainer extends Component {
    constructor(props) {
        super(props);

        this.closeModal = this.closeModal.bind(this);
    }

    componentWillMount() {
        if (this.props.modalDraftIsOpen) {
            this.props.setContentBlur(5);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.modalDraftIsOpen) {
            this.props.setContentBlur(5);
        }  else {
            this.props.setContentBlur(0);
        }
    }

    closeModal(name) {
        this.props.modalsActions.changeModalVisibility(name, false);
    }

    render() {
        const { modalDraftIsOpen } = this.props;

        return (
            <div>
                <ReactModal
                    isOpen={modalDraftIsOpen}
                    style={
                        {
                            overlay: {
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                zIndex: '2'
                            },
                            content: {
                                backgroundColor: '#303131',
                                border: '1px solid #000',
                                borderRadius: 0
                            }
                        }
                    }
                    ariaHideApp={false}
                    shouldCloseOnOverlayClick={false}
                    onRequestClose={() => this.closeModal('modalDraft')}
                    closeTimeoutMS={500}
                    role="dialog"
                    className='draft-modal'>
                    <div className="modal-header">
                        <h1>
                            Draft Tour
                        </h1>
                        <div className="modal-close">
                            <button className="btn btn-transparent" onClick={() => this.closeModal('modalDraft')}>
                                &times;
                                <Ink />
                            </button>
                        </div>
                    </div>
                    <div className="modal-body">
                        <p className="draft-message">
                            This tour is in draft status. Please publish the tour to remove this message.
                        </p>
                    </div>
                </ReactModal>
            </div>
        );
    }
}

DraftModalContainer.propTypes = {
    modalDraftIsOpen: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
    return {
        modalDraftIsOpen: state.modals.modalDraftIsOpen
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        modalsActions: bindActionCreators(ModalsActions, dispatch),
        setContentBlur: bindActionCreators(setContentBlur, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DraftModalContainer)
